import React, {Component} from 'react'
import {Image, Button, Tooltip, OverlayTrigger} from 'react-bootstrap'
import Cropper from 'react-cropper'
import {Actions} from 'jumpstate'
import {MdPanTool, MdDone} from '../Common/ReactIcons/icons'
import 'cropperjs/dist/cropper.css'

const defaultAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class NewHorseAvatar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      src: '',
      showImage: true,
      staticAvatar: defaultAvatar,
      showHelp: true,
      showCropper: false
    }
    this.cropMove = this.cropMove.bind(this)
    this.cropEnd = this.cropEnd.bind(this)
    this.saveAvatar = this.saveAvatar.bind(this)
  }

  cropMove (e) {
    this.setState({showHelp: false})
  }

  cropEnd (e) {
    this.setState({showHelp: true})
  }

  componentWillMount () {
    const hasAvatar = this.props.avatar.hasOwnProperty('url')
    this.setState({src: hasAvatar ? this.props.avatar.url.orginal : this.state.staticAvatar, showCropper: hasAvatar})
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.avatar !== nextProps.avatar) {
      const hasAvatar = nextProps.avatar.hasOwnProperty('url')
      this.setState({src: nextProps.avatar.url ? nextProps.avatar.url.orginal : this.state.staticAvatar, showCropper: hasAvatar})
    }
  }

  saveAvatar () {
    if (!this.props.avatar.photo_id) { return undefined }
    const {x, y, width, height} = this.refs.cropper.getData()
    this.setState({showCropper: false,
      src: '',
      staticAvatar: this.refs.cropper.getCroppedCanvas().toDataURL()
    }, () => this.setState({src: this.state.staticAvatar}))
    Actions.setNewHorseAvatar({
      avatar_id: this.props.avatar.photo_id,
      avatar_x: x,
      avatar_y: y,
      avatar_w: width,
      avatar_h: height,
      staticAvatar: this.refs.cropper.getCroppedCanvas().toDataURL()
    })
  }

  render () {
    const {showHelp, src, showCropper} = this.state
    const {avatar} = this.props

    const tooltipSave = (
      <Tooltip id="tooltip">ذخیره آواتار</Tooltip>
    )

    return (
      <div className="UserCover">
        <Image src={avatar.staticAvatar ? avatar.staticAvatar : src} className="Avatar AvatarHorse" />
        {showCropper &&
          <div className="avatar-cropper-box Avatar">
            <Cropper
              style={{ height: 170, width: '100%' }}
              aspectRatio={1 / 1}
              preview=".AvatarHorse"
              guides={false}
              src={src}
              ref="cropper"
              viewMode={3}
              dragMode="move"
              autoCropArea={1}
              restore={false}
              modal={false}
              highlight={false}
              cropBoxMovable={false}
              cropBoxResizable={false}
              toggleDragModeOnDblclick={false}
              minContainerWidth={170}
              minContainerHeight={170}
              cropmove={this.cropMove}
              cropend={this.cropEnd}
            />

            {showHelp &&
            <div className="help-cropper">
              <p><span>بزرگنمایی</span> <div className="MouseScrollIcon" /></p>
              <p><span>جابه‌جایی</span> <MdPanTool /></p>
            </div>
          }
          </div>
        }
        {showCropper && <div>
          <OverlayTrigger placement="bottom" overlay={tooltipSave}>
            <Button className="SaveAvatar" bsStyle="primary" bsSize="small" style={{zIndex: 100}} onClick={this.saveAvatar}><MdDone /></Button>
          </OverlayTrigger>
        </div>}
      </div>
    )
  }
}

NewHorseAvatar.propTypes = {
  avatar: React.PropTypes.object.isRequired
}

export default NewHorseAvatar



// WEBPACK FOOTER //
// ./src/components/NewHorse/NewHorseAvatar.js